import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AwpNRDApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  NRD_getSpeedTestHistory (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getSpeedTestHistory/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_CheckPianificazione (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_CheckPianificazione/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_preConfiguration (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_preConfiguration`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  NRD_speedtest (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_speedtest`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  NRD_migration (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_migration`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  NRD_updateSDB (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_updateSDB`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  NRD_getPianificabili (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getPianificabili`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_getGlobal (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getGlobal`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_getSintesiGrouByMonth (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_GetSintesiGrouByMonth/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_getTreeTotal (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getTreeTotal`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_getTreeTotalTIM (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getTreeTotalTIM`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_getTreeTotalFastweb (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getTreeTotalFastweb`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_getTreeTotalWind (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getTreeTotalWind`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_GetSintesiWeek (year, week): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_GetSintesiWeek/${year}/${week}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  NRD_restartMigration (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_restartMigration`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  NRD_continueMigration (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_continueMigration`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  NRD_forceStartMigration (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_forceStartMigration`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  NRD_getCessazioni (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_getCessazioni`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
  NRD_change_TGU(obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/NRD/NRD_ChangeTGU`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
